import type { Icon } from "@phosphor-icons/react";
import {
	InstagramLogoIcon,
	MessengerLogoIcon,
	TelegramLogoIcon,
	ThreadsLogoIcon,
	TiktokLogoIcon,
	WhatsappLogoIcon,
	XLogoIcon,
} from "@phosphor-icons/react";

const ICONS: Record<string, Icon> = {
	whatsapp: WhatsappLogoIcon,
	telegram: TelegramLogoIcon,
	messenger: MessengerLogoIcon,
	instagram: InstagramLogoIcon,
	threads: ThreadsLogoIcon,
	x: XLogoIcon,
	tiktok: TiktokLogoIcon,
};

export function EngageNetworkIcon({ network, size = 56 }: { network: string; size?: number }) {
	const Logo = ICONS[network];
	const mark = Math.round(size * 0.62);
	return (
		<span className={`engage-tile net-${network}`} style={{ width: size, height: size }} aria-hidden="true">
			{network === "linkedin" ? (
				<svg viewBox="0 0 56 56" width={size} height={size}>
					<path
						fill="#fff"
						d="M18.2 22.6h5.4V40h-5.4V22.6zM20.9 16.2c1.8 0 3.2 1.4 3.2 3.2s-1.4 3.2-3.3 3.2-3.2-1.4-3.2-3.2 1.5-3.2 3.3-3.2zM28.2 22.6h5.2v2.4h.1c.7-1.4 2.5-2.8 5.2-2.8 5.5 0 6.5 3.6 6.5 8.3V40h-5.4v-8.7c0-2.1 0-4.8-2.9-4.8s-3.4 2.3-3.4 4.6V40h-5.3V22.6z"
					/>
				</svg>
			) : Logo ? (
				<Logo size={mark} weight="fill" color="#fff" />
			) : (
				<svg viewBox="0 0 56 56" width={size} height={size}>
					<text x="28" y="34" textAnchor="middle" fill="#fff" fontSize="16" fontWeight="700">
						{(network.slice(0, 1) || "?").toUpperCase()}
					</text>
				</svg>
			)}
		</span>
	);
}
